module.exports = __webpack_public_path__ + "img/IMG-20191212-WA0013.1813751e.jpg";